/**
 * Configures the application so it will use the HTML5 push navigation mode.
 * @param {ngLocationProvider} $locationProvider The interface AngularJS uses for handling URLs
 *                                               and locations.
 * @ngesdoc config
 * @ngprovider $locationProvider
 * @ngmodule root
 */
const locationProviderConfig = ($locationProvider) => {
  'ngInject';

  $locationProvider.html5Mode(true);
};

export default locationProviderConfig;
